<template>
  <div class="admin">
    <PollTable />
  </div>
</template>

<script>
// @ is an alias to /src
import PollTable from '@/components/Admin/DataTables/PollTable.vue';

export default {
  name: 'Admin',
  components: {
    PollTable
  }
};
</script>
